import { StatsModel } from '@shared/models/stats'

export const getTotalStats = (stats: StatsModel): number =>
  Object.keys(stats).reduce((total, stat) => total + stats[stat], 0)
